import React from "react";

import {
    YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";


import PolicyHolderAccidentForm from "../common/policy-holder-accident-form";
import {ValidateStep4Data} from "@validators/taxi-insurance-form/step4-validator";
import {showValidationErrorsModal} from "@utils/modal-manager";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";

import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import AddItemButtonComponent from "@components/common/form-controls/buttons/add-item-button";
import PreviousButtonComponent from "@components/common/form-controls/buttons/previous-button";
import NextButtonComponent from "@components/common/form-controls/buttons/next-button";
import PolicyHolderConvictionForm from "../common/policy-holder-conviction-form";
import {CommonPolicyHolderClaimsForm} from "@components/common/sub-components/insurance-form-parts/policy-holder-claims-form/common-policy-holder-claims-form";
import {
   CommonPolicyHolderConvictionsForm
} from "@components/common/sub-components/insurance-form-parts/policy-holder-convictions-form/common-policy-holder-convictions-form";
import {WizardStepButtonsBlock} from "@components/common/form-blocks/other/wizard-step-buttons-block";


export default function IF_Step4(
    {
        data,
        handlers,
        setCurrentStep,
        handlePolicyHolderAccidentPropChange,
        handlePolicyHolderConvictionPropChange,
        addPolicyHolderAccident,
        addPolicyHolderConviction,
        removePolicyHolderAccident,
        removePolicyHolderConviction,
    }
) {

    const STEP = 4;

    const onPrevBtnClick = (event) => {

        setCurrentStep(STEP - 1);

    }

    function onNextBtnClick() {

        let validationResult = ValidateStep4Data(data);

        if (validationResult.length) {

            showValidationErrorsModal({
                validationResult: validationResult
            });


        } else {
            setCurrentStep(STEP + 1);
        }


    }


    return (
        <div className={`if-step-${STEP}`}>
           
            {/*
                Claims and convictions ...
            */}

            <SectionHeading
                text="Claims & convictions"
            />
           
           <CommonPolicyHolderClaimsForm
              sectionHeading={`Motor accidents or claims`}
              showSectionHeading={false}
              data={data}
              onChange={handlers.onControlChange}
              
              addPolicyHolderAccident={addPolicyHolderAccident}
              handlePolicyHolderAccidentPropChange={handlePolicyHolderAccidentPropChange}
              removePolicyHolderAccident={removePolicyHolderAccident}
           />
           
           <CommonPolicyHolderConvictionsForm
              sectionHeading={`Motor convictions`}
              showSectionHeading={false}
              data={data}
              onChange={handlers.onControlChange}
              
              addPolicyHolderConviction={addPolicyHolderConviction}
              handlePolicyHolderConvictionPropChange={handlePolicyHolderConvictionPropChange}
              removePolicyHolderConviction={removePolicyHolderConviction}
           />

            {/*
                Step buttons ....
            */}

           <WizardStepButtonsBlock
              onPrevBtnClick={onPrevBtnClick}
              onNextBtnClick={onNextBtnClick}
              
           />

        </div>
    )
}